const DragAndDropIndicator = () => {
  return (
    <div
      style={{
        backgroundColor: "var(--col-interaction-tertiary)",
        height: "4px",
        borderRadius: "3px",
        width: "100%",
      }}
    ></div>
  );
};

export default DragAndDropIndicator;
